module.exports = __webpack_public_path__ + "static/media/museosansitalic.d602e2c7.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/museosansitalic.woff
// module id = 647
// module chunks = 0